/* Coziness: Variation-Product Hover Preview
   Hovers on .cz-variation-preview wrappers swap the hero gallery img
   (vendor/title/price) + show an overlay card. Desktop mouse/pen only. */

(function () {
    'use strict';
    var started = false;

    function start() {
        if (started) return;
        started = true;

        if (window.matchMedia && window.matchMedia('(max-width: 999px)').matches) return;

        var variations = document.querySelectorAll('.cz-variation-preview');
        if (!variations.length) return;

        var gallery = document.querySelector('.product-gallery');
        if (!gallery) return;

        /* Find the hero <img> of the CURRENTLY VISIBLE gallery cell.
           After thumbnail-navigation the visible cell is no longer cell 0,
           so we walk all cells and pick the one whose offsetLeft aligns
           best with the carousel's current scrollLeft. */
        function currentHeroImg() {
            var carousel = gallery.querySelector('scroll-carousel, .product-gallery__carousel');
            if (carousel) {
                var cells = carousel.querySelectorAll('.product-gallery__media');
                if (cells.length) {
                    var sl = carousel.scrollLeft;
                    var best = null, bestDist = Infinity;
                    cells.forEach(function (c) {
                        if (c.hidden) return;
                        var d = Math.abs(c.offsetLeft - sl);
                        if (d < bestDist) { bestDist = d; best = c; }
                    });
                    if (best) {
                        var img = best.querySelector('img');
                        if (img) return img;
                    }
                }
            }
            /* Fallback: first non-hidden media */
            var imgs = gallery.querySelectorAll('.product-gallery__media:not([hidden]) img');
            return imgs[0] || gallery.querySelector('.product-gallery__media img');
        }

        var orig = null;
        var swappedImg = null;   /* keep ref to the exact <img> we modified */
        var hideTimer = null;
        var activeWrap = null;

        function show(el) {
            var img = currentHeroImg();
            if (!img) return;

            /* If user navigated between swatches without a proper restore
               (e.g. rapid-fire), first restore whatever we last swapped. */
            if (swappedImg && swappedImg !== img) {
                hardRestore();
            }

            /* CRITICAL: only snapshot the originals on FIRST swap of this
               img. On a subsequent hover while img is already swapped,
               re-reading img.getAttribute('src') would give us the
               PREVIOUS preview's src (already swapped), contaminating
               orig with a variation image. Then restore would put the
               wrong image back. */
            if (swappedImg !== img || orig === null) {
                swappedImg = img;
                orig = {
                    src: img.getAttribute('src'),
                    srcset: img.getAttribute('srcset'),
                    sizes: img.getAttribute('sizes')
                };
            }

            var newSrc = el.getAttribute('data-cz-preview-image');
            if (newSrc) {
                /* Clear srcset FIRST so the browser falls back to the src
                   attribute we assign next. Setting src alone doesn't win
                   against a non-empty srcset. */
                img.removeAttribute('srcset');
                img.removeAttribute('sizes');
                img.src = newSrc;
            }
            activeWrap = el;
        }

        function hardRestore() {
            if (swappedImg && orig) {
                if (orig.src !== null) swappedImg.src = orig.src; else swappedImg.removeAttribute('src');
                if (orig.srcset !== null) swappedImg.setAttribute('srcset', orig.srcset); else swappedImg.removeAttribute('srcset');
                if (orig.sizes !== null) swappedImg.setAttribute('sizes', orig.sizes); else swappedImg.removeAttribute('sizes');
            }
            orig = null;
            swappedImg = null;
        }

        function restore() {
            hardRestore();
            activeWrap = null;
        }

        function gateType(ev) {
            if (!ev.pointerType) return true;
            return ev.pointerType === 'mouse' || ev.pointerType === 'pen';
        }

        variations.forEach(function (v) {
            if (v.dataset.czPreviewBound) return;
            v.dataset.czPreviewBound = '1';

            function onEnter(ev) {
                if (!gateType(ev)) return;
                if (activeWrap === v) return;
                clearTimeout(hideTimer);
                show(v);
            }
            function onLeave(ev) {
                if (!gateType(ev)) return;
                var to = ev.relatedTarget;
                if (to && to.closest && to.closest('.cz-variation-preview')) return;
                clearTimeout(hideTimer);
                hideTimer = setTimeout(restore, 80);
            }

            v.addEventListener('pointerenter', onEnter);
            v.addEventListener('pointerleave', onLeave);
            v.addEventListener('mouseenter', onEnter);
            v.addEventListener('mouseleave', onLeave);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
    window.addEventListener('load', function () { started = false; start(); });
})();
